import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ authenticated, component: Component }) => {
    return authenticated ? (Component) : (
        <Navigate to='/signin' {...alert("Invalid access. Please log in again.")} />
    )
}

export default PrivateRoute;